// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RouteLists_pageContainer__KyDgn {
  flex: 1 1;
  font-family: Arial, sans-serif;
  padding: 0 10px;
  height: 100%;
  overflow-y: auto;
}

.RouteLists_pageTitleRed__XKzAl {
  color: red;
  font-size: 24px;
}

.RouteLists_errorContainer__13PEx {
  /* твоё оформление */
}

.RouteLists_header__BzKmT {
  position: relative;
}

.RouteLists_pageTitle__ZsuWe {
  font-size: 24px;
}

.RouteLists_loaderContainer__GEzh4,
.RouteLists_loader__abKAy,
.RouteLists_empty__W2UBc {
  /* твои стили */
}

.RouteLists_noRoutes__AVFW9 {
  font-size: 16px;
  text-align: center;
}

.RouteLists_mainBlock__6IMJc {
    background-color: white; /* Белый фон */
    border: 1px solid rgb(0, 123, 255); /* Граница синего цвета */
    border-radius: 8px; /* Скругленные углы */
    padding: 15px; /* Отступы внутри блока */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Легкая тень */
    transition: transform 0.2s, box-shadow 0.2s; /* Плавные изменения */
    display: flex;
    flex-direction: column; /* Расположение элементов по вертикали */
    margin-bottom: 10px; /* Отступ снизу */
    
}

.RouteLists_mainBlock__6IMJc p {
    margin: 5px 0; /* Отступы для абзацев */
    font-size: 17px; /* Размер шрифта */
}

.RouteLists_number__WZBxK {
  font-size: 18px;
  margin-bottom: 8px;
}

.RouteLists_progressContainer__cLnW0 {
  width: 100%;
  height: 10px;
  background-color: #f3f3f3;
  margin: 10px 0;
  border-radius: 4px;
}

.RouteLists_progressBar__CYoi8 {
  display: flex;
  height: 10px;
  border-radius: 4px;
}

.RouteLists_progressDelivered__Db-rS {
  background-color: rgb(40, 167, 69);
}

.RouteLists_progressInProgress__b3eiH {
  background-color: rgb(0, 123, 255);
}

.RouteLists_progressUndelivered__CIfpq {
  background-color: rgb(220, 53, 69);
}

.RouteLists_statusContainer__hRQw2 {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 15px;
  color: #333;
}

.RouteLists_statusItem__E6w-S {
  display: flex;
  justify-content: space-between;
  width: 30%;
  font-weight: bold;
}

.RouteLists_deliveredCount__JS\\+da {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 2px 5px;
  border-radius: 3px;
}

.RouteLists_topSpacing__be3db {
  height: 70px;
}

.RouteLists_bottomSpacing__QGNG7 {
  height: 170px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/RouteLists/RouteLists.module.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;IACI,uBAAuB,EAAE,cAAc;IACvC,kCAAkC,EAAE,yBAAyB;IAC7D,kBAAkB,EAAE,qBAAqB;IACzC,aAAa,EAAE,yBAAyB;IACxC,wCAAwC,EAAE,gBAAgB;IAC1D,2CAA2C,EAAE,sBAAsB;IACnE,aAAa;IACb,sBAAsB,EAAE,wCAAwC;IAChE,mBAAmB,EAAE,iBAAiB;;AAE1C;;AAEA;IACI,aAAa,EAAE,wBAAwB;IACvC,eAAe,EAAE,kBAAkB;AACvC;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":[".pageContainer {\r\n  flex: 1;\r\n  font-family: Arial, sans-serif;\r\n  padding: 0 10px;\r\n  height: 100%;\r\n  overflow-y: auto;\r\n}\r\n\r\n.pageTitleRed {\r\n  color: red;\r\n  font-size: 24px;\r\n}\r\n\r\n.errorContainer {\r\n  /* твоё оформление */\r\n}\r\n\r\n.header {\r\n  position: relative;\r\n}\r\n\r\n.pageTitle {\r\n  font-size: 24px;\r\n}\r\n\r\n.loaderContainer,\r\n.loader,\r\n.empty {\r\n  /* твои стили */\r\n}\r\n\r\n.noRoutes {\r\n  font-size: 16px;\r\n  text-align: center;\r\n}\r\n\r\n.mainBlock {\r\n    background-color: white; /* Белый фон */\r\n    border: 1px solid rgb(0, 123, 255); /* Граница синего цвета */\r\n    border-radius: 8px; /* Скругленные углы */\r\n    padding: 15px; /* Отступы внутри блока */\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Легкая тень */\r\n    transition: transform 0.2s, box-shadow 0.2s; /* Плавные изменения */\r\n    display: flex;\r\n    flex-direction: column; /* Расположение элементов по вертикали */\r\n    margin-bottom: 10px; /* Отступ снизу */\r\n    \r\n}\r\n\r\n.mainBlock p {\r\n    margin: 5px 0; /* Отступы для абзацев */\r\n    font-size: 17px; /* Размер шрифта */\r\n}\r\n\r\n.number {\r\n  font-size: 18px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.progressContainer {\r\n  width: 100%;\r\n  height: 10px;\r\n  background-color: #f3f3f3;\r\n  margin: 10px 0;\r\n  border-radius: 4px;\r\n}\r\n\r\n.progressBar {\r\n  display: flex;\r\n  height: 10px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.progressDelivered {\r\n  background-color: rgb(40, 167, 69);\r\n}\r\n\r\n.progressInProgress {\r\n  background-color: rgb(0, 123, 255);\r\n}\r\n\r\n.progressUndelivered {\r\n  background-color: rgb(220, 53, 69);\r\n}\r\n\r\n.statusContainer {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 12px;\r\n  margin-top: 15px;\r\n  color: #333;\r\n}\r\n\r\n.statusItem {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: 30%;\r\n  font-weight: bold;\r\n}\r\n\r\n.deliveredCount {\r\n  position: absolute;\r\n  top: 5px;\r\n  right: 5px;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  color: white;\r\n  padding: 2px 5px;\r\n  border-radius: 3px;\r\n}\r\n\r\n.topSpacing {\r\n  height: 70px;\r\n}\r\n\r\n.bottomSpacing {\r\n  height: 170px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `RouteLists_pageContainer__KyDgn`,
	"pageTitleRed": `RouteLists_pageTitleRed__XKzAl`,
	"errorContainer": `RouteLists_errorContainer__13PEx`,
	"header": `RouteLists_header__BzKmT`,
	"pageTitle": `RouteLists_pageTitle__ZsuWe`,
	"loaderContainer": `RouteLists_loaderContainer__GEzh4`,
	"loader": `RouteLists_loader__abKAy`,
	"empty": `RouteLists_empty__W2UBc`,
	"noRoutes": `RouteLists_noRoutes__AVFW9`,
	"mainBlock": `RouteLists_mainBlock__6IMJc`,
	"number": `RouteLists_number__WZBxK`,
	"progressContainer": `RouteLists_progressContainer__cLnW0`,
	"progressBar": `RouteLists_progressBar__CYoi8`,
	"progressDelivered": `RouteLists_progressDelivered__Db-rS`,
	"progressInProgress": `RouteLists_progressInProgress__b3eiH`,
	"progressUndelivered": `RouteLists_progressUndelivered__CIfpq`,
	"statusContainer": `RouteLists_statusContainer__hRQw2`,
	"statusItem": `RouteLists_statusItem__E6w-S`,
	"deliveredCount": `RouteLists_deliveredCount__JS+da`,
	"topSpacing": `RouteLists_topSpacing__be3db`,
	"bottomSpacing": `RouteLists_bottomSpacing__QGNG7`
};
export default ___CSS_LOADER_EXPORT___;
